import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import Login from './pages/Login'
import OAuthCallback from './pages/OAuthCallback'
import OAuthSuccess from './pages/OAuthSuccess'
import Dashboard from './pages/Dashboard'
import EmailPanel from './pages/EmailPanel'
import CohortsPanel from './pages/CohortsPanel'
import Layout from './components/Layout'
import Breadcrumb from './components/Breadcrumb'

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#6b7280'
      }}>
        Loading...
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return children
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<OAuthCallback />} />
          <Route path="/oauth-success" element={<OAuthSuccess />} />
          
          {/* Protected routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                <Breadcrumb />
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Layout>
                <Breadcrumb />
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/emails" element={
            <ProtectedRoute>
              <Layout>
                <Breadcrumb />
                <EmailPanel />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/cohorts" element={
            <ProtectedRoute>
              <Layout>
                <Breadcrumb />
                <CohortsPanel />
              </Layout>
            </ProtectedRoute>
          } />
          
          {/* Catch all route - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
